
import { Grid } from "@mui/material";
import { useEffect, useMemo, useState } from "react";

import Box from "../../components/Box";
import Helpers from "../../commons/helpers";
import Button from "../../components/Button";
import useStrings from "../../hooks/useStrings";
import Typography from "../../components/Typography";
import CardUserRole from "../../components/Staff/cardUserRole";
import CardUserGroup, { IRecordWorkingGroup } from "../../components/Staff/cardUserGroup";
import CardStaffInfo from "../../components/Staff/cardStaffInfo";

import useContainerGroup from "../../hooks/useContainerGroup";
import useContainerStaff from "../../hooks/useContainerStaff";
import UserService from "../../services/identity/user.service";
import AddressService from "../../services/common/address.service";

import { MainComponent } from "../main";
import { commonGetAllDataRole } from "../role/list";
import { getAllDataCodename } from "../codename/list";
import { RoleHelpers } from "../../commons/roleHelpers";
import { useCommonComponentContext } from "../../providers/CommonComponentProvider";
import { ICodename, ILableOrganization, IPropDetailContainer } from "../../commons/interfaces";
import {
    ActionRequest, CodeNameCommon, GroupType,
    InvitationDetailType, Mode, Status,
} from "../../constants/enums";



export interface IDetailUser {
    id?: string;
    avatarId?: string;
    avatarUrl?: string;
    email?: string;
    fullName?: string,
    phoneNumber?: string;

    roleCodes?: string[];
    groupUsers?: IRecordWorkingGroup[];

    organizationUserProfile?: {
        id: string,
        userId: string,
        userType: number,
        organizationId: string,

        gender: number,
        email?: string,
        lastName: string,
        firstName: string,
        phoneNumber?: string,
        dateOfBirth: number | string,

        idCardNo: string,
        idCardIssuedPlace: string,
        idCardIssuedDate: number | string,
        socialInsuranceCode: string,
        employmentDate: number | string,
        extraInformation?: { description?: string },

        passportNo?: string;
        nationality?: string;
        passportIssuedPlace?: string;
        passportExpiredDate?: number | string;
        status?: number;
    },
}

const StaffEditContainer = ({
    mode,
    idDetail,

    title,
    lableGroup,
    lableStaff,

    onGoBack,
    onChangeMode,
    hidenStatus,
    cardChildrens,
    hidenIdCardInfo,
    hidenPassportInfo,
    hidenActionUpdate,
    requiredInputRole,
}: IPropDetailContainer & ILableOrganization & {
    title?: string;
    hidenStatus?: boolean;
    hidenIdCardInfo?: boolean;
    requiredInputRole?: boolean;
    hidenPassportInfo?: boolean;
    hidenActionUpdate?: boolean;
    cardChildrens?: JSX.Element[];
}) => {
    const strings = useStrings();

    const { checkGeneByGroup, getAllDataGroup } = useContainerGroup();
    const {
        getDetailUserGroup,
        isPermissionCheckGroupManager
    } = useContainerStaff();

    const {
        clientId,
        language,
        userInfo,
        serviceCode,
        onError,
        onShowLoading,
        onHideLoading,
    } = useCommonComponentContext();

    const [allowUpdate, setAllowUpdate] = useState<boolean>(false);
    const [dataDetailUser, setDataDetailUser] = useState<IDetailUser>({});
    const [listCountrySelect, setListCountrySelect] = useState<ICodename[]>([]);

    const [dataRoleSelect, setDataRoleSelect] = useState<ICodename[]>([]);
    const [dataUserRoleDisable, setDataUserRoleDisable] = useState<string[]>([]);

    const [isInvitation, setIsInvitation] = useState<boolean>(false);
    const [dataGroupSelect, setDataGroupSelect] = useState<ICodename[]>([]);
    const [dataUserTitleSelect, setDataUserTitleSelect] = useState<ICodename[]>([]);

    const newLableStaff = useMemo(() => (
        (lableStaff || strings.Common.STAFF).toLowerCase()
    ), [lableStaff, strings]);

    const newLableGroup = useMemo(() => (
        (lableGroup || strings.Common.GROUP).toLowerCase()
    ), [lableGroup, strings]);

    useEffect(() => {
        (
            async () => {
                try {
                    onShowLoading();

                    // get Country
                    const resultAddress = await AddressService.getCountries({ type: 1 });
                    const newDataAddress: ICodename[] = [...resultAddress || []].map((item) => {
                        return {
                            code: item.code,
                            name: item.name,
                        };
                    });

                    setListCountrySelect(newDataAddress);

                    // get Group
                    let dataGroupTemp: ICodename[] = [];
                    const resultGetAllGroup = await getAllDataGroup({
                        clientId: clientId,
                        listStatus: [Status.Active],
                        organizationId: userInfo?.userProfile?.organizationId,
                    });
                    [...resultGetAllGroup || []].forEach(item => {
                        if (Number(item.detail?.type) !== GroupType.Company) {
                            const checkGeneItem = checkGeneByGroup({
                                gene: item.detail?.gene,
                                listGroupSlice: userInfo?.listGroup,
                                roleType: userInfo?.userProfile?.roleType,
                                organizationId: userInfo?.userProfile?.organizationId,
                            });
                            checkGeneItem && dataGroupTemp.push({
                                ...item,
                                name: Helpers.renderValueByLanguage({ data: item.name, currentLanguage: language }),
                            });
                        }
                    });

                    setDataGroupSelect(dataGroupTemp);

                    // get Role
                    let dataRoleTemp: ICodename[] = await commonGetAllDataRole({
                        clientId: clientId,
                        status: Status.Active,
                        organizationId: userInfo?.userProfile?.organizationId,
                    });

                    setDataRoleSelect(dataRoleTemp);

                    // get Codename
                    const resultGetAllCodeName = await getAllDataCodename({
                        serviceCode: serviceCode,
                        group: [CodeNameCommon.USER_TITLE],
                        organizationId: userInfo?.userProfile?.organizationId,
                    });
                    const dataUserTitleTemp = resultGetAllCodeName.get(CodeNameCommon.USER_TITLE);

                    setDataUserTitleSelect(dataUserTitleTemp);

                    // get Detail
                    !Helpers.isNullOrEmpty(idDetail) &&
                        await getDetailUserByID(idDetail);
                } catch (error) {

                } finally {
                    onHideLoading();
                }
            }
        )();
    }, [idDetail, userInfo?.userProfile?.organizationId]);

    const getDetailUserByID = async (id: string) => {
        try {
            onShowLoading();

            const userResult = await UserService.getDetail({
                id: id,
                clientId: clientId,
                organizationId: userInfo?.userProfile?.organizationId
            });

            let arrRoleTypes: number[] = [];
            let roleCodesTemp: string[] = [];
            let newRoleTemp: ICodename[] = [];
            let newRoleDisabled: string[] = [];
            let groupUserTemp: IRecordWorkingGroup[] = [];

            if (!Helpers.isNullOrEmpty(userResult?.invitation) &&
                [...userResult?.invitation?.invitationDetails || []].length > 0) {

                setIsInvitation(true);

                [...userResult?.invitation?.invitationDetails || []].forEach((item: any) => {
                    if (item.type === InvitationDetailType.Role) {
                        if (!Helpers.isNullOrEmpty(item.roleCode)) {
                            roleCodesTemp.push(item.roleCode);
                        }
                    }

                    if (item.type === InvitationDetailType.Group) {
                        groupUserTemp.push({
                            id: item.id,
                            groupId: item.groupId,
                            manager: item.manager,
                            userTitle: item.title,
                            default: item.groupDefault,
                            action: ActionRequest.Update,
                        });
                    }
                });
            } else {
                if ([...userResult?.userRoles || []].length > 0) {
                    [...userResult?.userRoles || []].forEach((el: any) => {
                        if (!Helpers.isNullOrEmpty(el.roleCode)) {
                            roleCodesTemp.push(el.roleCode);

                            newRoleTemp.push({
                                code: el.roleCode,
                                name: el.roleName,
                                detail: {
                                    roleType: el.roleType,
                                    roleLevel: el.roleLevel
                                }
                            });

                            if (RoleHelpers.isOrganizationOwner(el.roleType)) {
                                newRoleDisabled.push(el.roleCode);
                            }
                        }

                        !Helpers.isNullOrEmpty(el.roleType)
                            && arrRoleTypes.push(RoleHelpers.getRole(Number(el.roleType)).roleDetailType);
                    });
                }

                [...userResult.groupUsers || []]?.forEach((e) => {
                    const nameTemp = Helpers.renderValueByLanguage({ data: e.groupName, currentLanguage: language });

                    groupUserTemp.push({
                        id: e.id,
                        groupId: e.groupId,
                        manager: e.manager,
                        default: e.default,
                        groupName: nameTemp,
                        userTitle: e.userTitle,
                        action: ActionRequest.Update,
                    });
                });
            };

            const newDataOrganizationUserProfile = {
                id: userResult?.organizationUserProfile?.id,
                userId: userResult?.organizationUserProfile?.userId,
                userCode: userResult?.organizationUserProfile?.userCode,
                userType: userResult?.organizationUserProfile?.userType,
                organizationId: userResult?.organizationUserProfile?.organizationId,

                gender: userResult?.organizationUserProfile?.gender,
                lastName: userResult?.organizationUserProfile?.lastName,
                firstName: userResult?.organizationUserProfile?.firstName,
                dateOfBirth: userResult?.organizationUserProfile?.dateOfBirth,
                email: userResult?.organizationUserProfile?.email || userResult?.phoneNumber,
                phoneNumber: userResult?.organizationUserProfile?.phoneNumber || userResult?.phoneNumber,

                employmentDate: userResult?.organizationUserProfile?.employmentDate,
                terminationtDate: userResult?.organizationUserProfile?.terminationtDate,

                idCardNo: userResult?.organizationUserProfile?.idCardNo,
                idCardIssuedDate: userResult?.organizationUserProfile?.idCardIssuedDate,
                idCardIssuedPlace: userResult?.organizationUserProfile?.idCardIssuedPlace,
                socialInsuranceCode: userResult?.organizationUserProfile?.socialInsuranceCode,
                extraInformation: Helpers.converStringToJson(userResult?.organizationUserProfile?.extraInformation)?.Description,

                passportNo: userResult?.organizationUserProfile?.passportNo,
                nationality: userResult?.organizationUserProfile?.nationality,
                passportIssuedPlace: userResult?.organizationUserProfile?.passportIssuedPlace,
                passportExpiredDate: userResult?.organizationUserProfile?.passportExpiredDate,

                status: userResult?.organizationUserProfile?.status,
            };

            const newDataDetailUser: IDetailUser = {
                id: id,
                email: userResult?.email,
                fullName: userResult?.fullName,
                avatarId: userResult?.avatarId,
                avatarUrl: userResult?.avatarUrl,
                phoneNumber: userResult?.phoneNumber,

                roleCodes: roleCodesTemp,
                groupUsers: groupUserTemp,

                organizationUserProfile: newDataOrganizationUserProfile
            };

            let isLessThanRoleType = true;
            if (arrRoleTypes.length > 0) {
                const newRoleType = RoleHelpers.getRole(Number(userInfo?.userProfile?.roleType)).roleDetailType
                isLessThanRoleType = (Math.min(...arrRoleTypes) <= newRoleType);
            }

            if (
                !hidenActionUpdate
                && isLessThanRoleType
            ) {
                setAllowUpdate(true);
            } else {
                setAllowUpdate(false);
                onChangeMode(Mode.View);
                setDataRoleSelect(newRoleTemp);
            }

            setDataDetailUser(newDataDetailUser);
            setDataUserRoleDisable(newRoleDisabled);

        } catch (error) {
            const e = Helpers.renderExceptionError(error);
            onError(e);
        } finally {
            onHideLoading();
        }
    };

    return (
        <MainComponent>
            <Box>
                <Grid container spacing={3}>
                    {/* Btutton Action */}
                    <Grid item xs={12}>
                        <Box sx={{
                            mb: 2,
                            display: "flex",
                            flexWrap: "wrap",
                            alignItems: "center",
                            justifyContent: !Helpers.isNullOrEmpty(title) ? "space-between" : "end",
                        }}>
                            {
                                !Helpers.isNullOrEmpty(title) &&
                                <Typography variant="h5">{title}</Typography>
                            }
                            <Box sx={{
                                gap: 1,
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "flex-end",
                            }}>
                                <Button color="secondary" onClick={onGoBack}>
                                    {strings.Common.GO_BACK}
                                </Button>
                                {
                                    allowUpdate &&
                                    (mode === Mode.View) &&
                                    <Button onClick={() => { onChangeMode(Mode.Update); }} >
                                        {strings.Common.EDIT}
                                    </Button>
                                }
                            </Box>
                        </Box>
                    </Grid>

                    <Grid item xs={12}>
                        <CardStaffInfo
                            mode={mode}
                            key={"CardStaffInfo"}
                            hidenStatus={hidenStatus}
                            newLableStaff={newLableStaff}
                            dataDetailUser={dataDetailUser}
                            hidenIdCardInfo={hidenIdCardInfo}
                            hidenPassportInfo={hidenPassportInfo}
                            listCountrySelect={listCountrySelect}
                            onCallBack={() => {
                                getDetailUserByID(dataDetailUser?.id);
                            }}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <CardUserRole
                            key={"CardUserRole"}
                            mode={mode}
                            newLableGroup={newLableGroup}
                            newLableStaff={newLableStaff}
                            dataRoleSelect={dataRoleSelect}
                            requiredRole={requiredInputRole}
                            dataUserRole={dataDetailUser?.roleCodes}
                            dataUserRoleDisable={dataUserRoleDisable}

                            userId={dataDetailUser?.organizationUserProfile?.userId}
                            organizationId={dataDetailUser?.organizationUserProfile?.organizationId}

                            onCallBack={async (newdata) => {
                                if (newdata.isGetUserGroup) {
                                    const groupUserTemp = await getDetailUserGroup({
                                        clientId: clientId,
                                        userId: dataDetailUser?.organizationUserProfile?.userId,
                                        organizationId: dataDetailUser?.organizationUserProfile?.organizationId,
                                    });

                                    setDataDetailUser(prev => ({
                                        ...prev,
                                        groupUsers: groupUserTemp,
                                        roleCodes: [...newdata.roleCodes || []],
                                    }));
                                } else {
                                    setDataDetailUser(prev => ({
                                        ...prev,
                                        roleCodes: [...newdata.roleCodes || []],
                                    }));
                                }
                            }}
                        />
                    </Grid>

                    {
                        cardChildrens?.map((itemCard, index) => (
                            <Grid item xs={12} key={`card_${index}`}>
                                {itemCard}
                            </Grid>
                        ))
                    }

                    <Grid item xs={12}>
                        <CardUserGroup
                            key={"CardUserGroup"}
                            mode={mode}
                            newLableGroup={newLableGroup}
                            newLableStaff={newLableStaff}

                            dataGroupSelect={dataGroupSelect}
                            dataUserTitleSelect={dataUserTitleSelect}

                            dataRowsUserGroup={dataDetailUser?.groupUsers}

                            isInvitation={isInvitation}
                            isPermissionCheckGroupManager={
                                isPermissionCheckGroupManager(
                                    [...dataRoleSelect || []],
                                    [...dataDetailUser?.roleCodes || []]
                                )
                            }

                            userId={dataDetailUser?.organizationUserProfile?.userId}
                            organizationId={dataDetailUser?.organizationUserProfile?.organizationId}

                            onCallBack={(newUserGroup) => {
                                setDataDetailUser(prev => ({
                                    ...prev,
                                    groupUsers: newUserGroup,
                                }));
                            }}
                        />
                    </Grid>
                </Grid>
            </Box>
        </MainComponent>
    );
};

export default StaffEditContainer;